import bignumJSON from './json';

export default bignumJSON;
